import React from "react";

const CollectionSearchDraw = ({ width = "70", height = "77" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 70 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.8113 0H1.61173C0.721598 0 0 0.721597 0 1.61173V74.9623C0 75.8525 0.721598 76.5741 1.61173 76.5741H40.8113C41.7014 76.5741 42.423 75.8525 42.423 74.9623V1.61173C42.423 0.721597 41.7014 0 40.8113 0Z"
      transform="translate(13.788)"
      fill="url(#paint0_linear)"
    />
    <path
      d="M39.8436 0H1.43312C0.641629 0 0 0.641628 0 1.43312V73.0722C0 73.8637 0.641629 74.5053 1.43312 74.5053H39.8436C40.6351 74.5053 41.2767 73.8637 41.2767 73.0722V1.43312C41.2767 0.641628 40.6351 0 39.8436 0Z"
      transform="translate(14.7 1.035)"
      fill="#fff"
    />
    <path
      d="M37.8457 0H1.36126C0.609456 0 0 0.608918 0 1.36006V69.3469C0 70.0981 0.609456 70.707 1.36126 70.707H37.8457C38.5975 70.707 39.207 70.0981 39.207 69.3469V1.36006C39.207 0.608918 38.5975 0 37.8457 0Z"
      transform="translate(15.4 2.8)"
      fill="#FCEBEA"
    />
    <path
      d="M0.344619 0.689241C0.534948 0.689241 0.68924 0.534949 0.68924 0.344621C0.68924 0.154292 0.534948 0 0.344619 0C0.154291 0 0 0.154292 0 0.344621C0 0.534949 0.154291 0.689241 0.344619 0.689241Z"
      transform="translate(41.267 3.68)"
      fill="#DBDBDB"
    />
    <path
      d="M4.21004 8.42009C6.53519 8.42009 8.42009 6.53519 8.42009 4.21004C8.42009 1.8849 6.53519 0 4.21004 0C1.8849 0 0 1.8849 0 4.21004C0 6.53519 1.8849 8.42009 4.21004 8.42009Z"
      transform="translate(17.168 13.103)"
      fill="#fff"
    />
    <path
      d="M7.4997 0H0V1.31544H7.4997V0Z"
      transform="translate(29.668 14.155)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 16.654)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 19.155)"
      fill="#fff"
    />
    <path
      d="M4.21004 8.42009C6.53519 8.42009 8.42009 6.53519 8.42009 4.21004C8.42009 1.8849 6.53519 0 4.21004 0C1.8849 0 0 1.8849 0 4.21004C0 6.53519 1.8849 8.42009 4.21004 8.42009Z"
      transform="translate(17.168 25.603)"
      fill="#fff"
    />
    <path
      d="M7.4997 0H0V1.31544H7.4997V0Z"
      transform="translate(29.668 26.654)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 29.155)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 31.655)"
      fill="#fff"
    />
    <path
      d="M4.21004 8.42009C6.53519 8.42009 8.42009 6.53519 8.42009 4.21004C8.42009 1.8849 6.53519 0 4.21004 0C1.8849 0 0 1.8849 0 4.21004C0 6.53519 1.8849 8.42009 4.21004 8.42009Z"
      transform="translate(17.168 38.103)"
      fill="#fff"
    />
    <path
      d="M7.4997 0H0V1.31544H7.4997V0Z"
      transform="translate(29.668 39.154)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 41.655)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 44.154)"
      fill="#fff"
    />
    <path
      d="M4.21004 8.42009C6.53519 8.42009 8.42009 6.53519 8.42009 4.21005C8.42009 1.8849 6.53519 0 4.21004 0C1.8849 0 0 1.8849 0 4.21005C0 6.53519 1.8849 8.42009 4.21004 8.42009Z"
      transform="translate(17.168 50.602)"
      fill="#fff"
    />
    <path
      d="M7.4997 0H0V1.31544H7.4997V0Z"
      transform="translate(29.668 51.654)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 54.155)"
      fill="#fff"
    />
    <path
      d="M20.6583 -3.07814e-06H0V1.31544H20.6583V-3.07814e-06Z"
      transform="translate(29.668 56.654)"
      fill="#fff"
    />
    <path
      d="M4.21004 8.42009C6.53519 8.42009 8.42009 6.53519 8.42009 4.21004C8.42009 1.8849 6.53519 2.82163e-06 4.21004 2.82163e-06C1.8849 2.82163e-06 0 1.8849 0 4.21004C0 6.53519 1.8849 8.42009 4.21004 8.42009Z"
      transform="translate(17.168 63.102)"
      fill="#fff"
    />
    <path
      d="M7.4997 0H0V1.31544H7.4997V0Z"
      transform="translate(29.668 64.155)"
      fill="#fff"
    />
    <path
      d="M20.6583 2.56512e-06H0V1.31544H20.6583V2.56512e-06Z"
      transform="translate(29.668 66.655)"
      fill="#fff"
    />
    <path
      d="M20.6583 0H0V1.31544H20.6583V0Z"
      transform="translate(29.668 69.154)"
      fill="#fff"
    />
    <path
      d="M70 0H0V25.877H70V0Z"
      transform="translate(0 30.953)"
      fill="url(#paint1_linear)"
    />
    <path
      d="M69.005 0H0V23.886H69.005V0Z"
      transform="translate(.498 31.45)"
      fill="#fff"
    />
    <path
      d="M5.97202 11.944C9.27028 11.944 11.944 9.27028 11.944 5.97202C11.944 2.67377 9.27028 0 5.97202 0C2.67377 0 0 2.67377 0 5.97202C0 9.27028 2.67377 11.944 5.97202 11.944Z"
      transform="translate(12.606 36.759)"
      fill="url(#paint2_linear)"
    />
    <path
      d="M5.308 10.616C8.23952 10.616 10.616 8.23952 10.616 5.308C10.616 2.37647 8.23952 0 5.308 0C2.37647 0 0 2.37647 0 5.308C0 8.23952 2.37647 10.616 5.308 10.616Z"
      transform="translate(13.27 37.423)"
      fill="#EF5753"
    />
    <g opacity="0.2" fill="#EF5753">
      <path
        opacity="0.2"
        d="M9.455 0H0V1.65901H9.455V0Z"
        transform="translate(29.028 38.749)"
      />
      <path
        opacity="0.2"
        d="M26.043 0H0V1.65901H26.043V0Z"
        transform="translate(29.028 41.9)"
      />
      <path
        opacity="0.2"
        d="M26.043 0H0V1.65901H26.043V0Z"
        transform="translate(29.028 45.053)"
      />
    </g>
    <path
      d="M6.84303 0.88992L5.67678 1.28256e-07L2.60462 4.02618L0.88992 2.71704L6.4128e-07 3.88328L2.29887 5.63791L2.30517 5.6295L2.8862 6.07289L6.84303 0.88992Z"
      transform="translate(15.22 39.712)"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-90 29.75 46.824) scale(76.5751)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 -6373.25 17240.3 0 14698.3 13996.6)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-90 3484.765 2051.655) scale(1357.68)"
      >
        <stop stopColor="gray" stopOpacity="0.25" />
        <stop offset="0.54" stopColor="gray" stopOpacity="0.12" />
        <stop offset="1" stopColor="gray" stopOpacity="0.1" />
      </linearGradient>
    </defs>
  </svg>
);

export default CollectionSearchDraw;



// WEBPACK FOOTER //
// ./src/Icons/CollectionSearchDraw.js